// Version utility for RAVAH CARBON app
// Automatically reads version from package.json

export interface AppVersion {
  version: string;
  buildDate: string;
  environment: string;
}

// Read version from environment variables (set at build time)
// Fallback to hardcoded version if env vars not available
const PACKAGE_VERSION = import.meta.env.VITE_APP_VERSION || '1.0.0';

// Get build date (set at build time)
const BUILD_DATE = import.meta.env.VITE_APP_BUILD_DATE || new Date().toISOString().split('T')[0];

// Get environment
const ENVIRONMENT = import.meta.env.MODE || 'development';

export const getAppVersion = (): AppVersion => ({
  version: PACKAGE_VERSION,
  buildDate: BUILD_DATE,
  environment: ENVIRONMENT,
});

export const getVersionDisplay = (): string => {
  const { version, environment } = getAppVersion();
  
  // Show environment in development
  //if (environment === 'development') {
  //  return `v${version} (dev)`;
  //}
  
  return `v${version}`;
};

export const getFullVersionInfo = (): string => {
  const { version, buildDate, environment } = getAppVersion();
  return `v${version} | ${buildDate} | ${environment}`;
};
